import React from 'react'
import PropTypes from "prop-types";
// Material UI
import Grid from "@mui/material/Grid";
import { Button, DialogActions, Typography } from '@mui/material';
// Icons
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
// Components
import Modal from '..';
// Hooks
import useStyles from './styles';

const NotificationModal = ({open, variant = 'info', onAccept = () => {}, children, ...rest}) => {
  const { classes } = useStyles();

  const iconMap = {
    warning: { icon: WarningIcon, text: "Atención", className: classes.warning },
    error: { icon: ErrorIcon, text: "Error", className: classes.error },
    info: { icon: InfoIcon, text: "Información", className: classes.info }
  };

  const GetVariantIcon = (variant) => {
    const { icon: Icon, text, className } = iconMap[variant] || iconMap.info;
    return (
      <>
        <Icon className={className} />
        <Typography variant="h5" color="primary">{text}</Typography>
      </>
    );
  };

  return (
    <Modal
      {...rest}
      open={open}
      onClose={onAccept}
      customButtons={() =>
          <DialogActions className={classes.buttonAccept}>
              <Button
                  onClick={onAccept}
                  color="primary"
                  variant="contained"
                  fullWidth
                  autoFocus
              >
                  Aceptar
              </Button>
          </DialogActions>
      }
    >
      <Grid container spacing={2} className={classes.root}>
        <Grid size={12}>
          {GetVariantIcon(variant)}
        </Grid>
        <Grid size={12}>
          {children}
        </Grid>
      </Grid>
    </Modal>
  );
}

Modal.prototype = {
  open: PropTypes.bool,
  variant: PropTypes.string,
  onAccept: PropTypes.func,
  children: PropTypes.node
};

export default NotificationModal